"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CDN_LEVEL_TRAVEL_CRM_SOUNDS = exports.CDN_LEVEL_TRAVEL_CRM = exports.CDN_LEVEL_TRAVEL = void 0;
var CDN_LEVEL_TRAVEL = 'https://cdn.yc.level.travel';
exports.CDN_LEVEL_TRAVEL = CDN_LEVEL_TRAVEL;
var CDN_LEVEL_TRAVEL_CRM = "".concat(CDN_LEVEL_TRAVEL, "/crm");
exports.CDN_LEVEL_TRAVEL_CRM = CDN_LEVEL_TRAVEL_CRM;
var CDN_LEVEL_TRAVEL_CRM_SOUNDS = "".concat(CDN_LEVEL_TRAVEL_CRM, "/sounds");
exports.CDN_LEVEL_TRAVEL_CRM_SOUNDS = CDN_LEVEL_TRAVEL_CRM_SOUNDS;